import { Component, OnInit } from '@angular/core';
import { TableModule } from 'primeng/table';
import { RouterModule } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { NextRaceDayWidgetComponent } from "../../league/nextRaceDay.component";
import { Router } from '@angular/router';
import { FieldsetModule } from 'primeng/fieldset';
import { RaceDaysOverviewWidgetComponent, RaceDaysPlanPreview } from "../../league/raceDaysOverview.component";
import { LeagueTableOverviewWidgetComponent } from "../../league/leagueTableOverview.component";
import { LeagueOverview } from "../../league/leagueOverview.component";
import { SeasonsService } from '../../service/seasons.service';

@Component({
    selector: 'app-liga-season-widget',
    standalone: true,
    templateUrl: './ligaseasonwidget.component.html',
    styleUrls: ['./ligaseasonwidget.component.scss'],
    imports: [
    TableModule,
    RouterModule,
    ButtonModule,
    FieldsetModule,
    NextRaceDayWidgetComponent,
    RaceDaysOverviewWidgetComponent,
    LeagueTableOverviewWidgetComponent,
    LeagueOverview
],
    providers: [SeasonsService],
})
export class LigaSeasonWidgetComponent implements OnInit {
    /** Season shown on the home page: the active one, else the most recent non-planning season. */
    currentSeasonId = 0;
    currentSeasonName: string | null = null;

    /** Only set while a season is really running. The league table stands for the
     *  season in progress, so between seasons it is hidden instead of showing the
     *  standings of the finished one. */
    activeSeasonId = 0;
    activeSeasonName: string | null = null;

    /** Season of the race calendar: the season being planned, so visitors see what
     *  is coming next; only without one it falls back to the current season. */
    calendarSeasonId = 0;
    calendarSeasonName: string | null = null;
    calendarPlan: RaceDaysPlanPreview | null = null;

    constructor(private router: Router, private seasonsService: SeasonsService) {}

    ngOnInit(): void {
        this.seasonsService.getSeasons().subscribe((seasons) => {
            const nonPlanning = seasons
                .filter((s) => s.status !== 'planning' && s.season_id != null)
                .sort((a, b) => (b.season_id ?? 0) - (a.season_id ?? 0));
            const active = nonPlanning.find((s) => s.status === 'active');
            const chosen = active ?? nonPlanning[0];
            if (chosen?.season_id != null) {
                this.currentSeasonId = chosen.season_id;
                this.currentSeasonName = chosen.name;
            }
            if (active?.season_id != null) {
                this.activeSeasonId = active.season_id;
                this.activeSeasonName = active.name;
            }

            // The season starting first is the one visitors are waiting for;
            // seasons without a date yet come last.
            const upcoming = seasons
                .filter((s) => s.status === 'planning' && s.season_id != null)
                .sort(
                    (a, b) =>
                        (a.start_date ?? '9999-99-99').localeCompare(b.start_date ?? '9999-99-99') ||
                        (a.season_id ?? 0) - (b.season_id ?? 0)
                )[0];
            const calendarSeason = upcoming ?? chosen;
            if (calendarSeason?.season_id != null) {
                this.calendarSeasonId = calendarSeason.season_id;
                this.calendarSeasonName = calendarSeason.name;
                // Rounds whose circuit is still open have no race day yet, so the
                // plan fills them in — while the season runs just as well as
                // while it is drafted. A finished season is history and gets no
                // rounds it never ran.
                const runningOrPlanned =
                    calendarSeason.status === 'planning' || calendarSeason.status === 'active';
                this.calendarPlan = runningOrPlanned
                    ? {
                          plannedRaces: calendarSeason.planned_races ?? null,
                          startDate: calendarSeason.start_date ?? null,
                          cadenceDays: calendarSeason.race_cadence_days ?? null,
                          note: calendarSeason.status === 'planning' ? 'Vorläufige Planung' : null
                      }
                    : null;
            }
        });
    }

    openTwitch(): void {
        window.open('https://www.twitch.tv/wookie__54', '_blank');
    }

}
